import { useAppContext } from 'components/AppContext';
import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { FloorPlanFileSource, FloorPlanFileSourceName } from 'constants/common';
import * as api from 'utils/api';

export default function AddFileForm({
  floorPlanId,
  refetch,
}) {
  const [addingFile, setAddingFile] = useState(false);
  const [file, setFile] = useState(null);
  const [source, setSource] = useState(FloorPlanFileSource.VIDEO);
  const { request } = useAppContext();
  const [uploading, setUploading] = useState(false);

  if (!addingFile) {
    return (
      <div style={{
        paddingTop: 16,
      }}
      >
        <Button onClick={() => {
          setAddingFile(true);
        }}
        >
          Add file
        </Button>
      </div>
    );
  }

  const reset = () => {
    setAddingFile(false);
    setFile(null);
    setSource(FloorPlanFileSource.VIDEO);
  };

  const upload = async () => {
    setUploading(true);

    const { result } = await request(api.uploadFile(file));

    if (!result) {
      setUploading(false);
      reset();
      return;
    }

    await request(api.createFloorPlanFile(floorPlanId, {
      fileKey: result.key,
      fileName: file.name,
      fileType: file.type,
      source,
    }));

    setUploading(false);
    reset();
    refetch();
  };

  return (
    <div style={{
      paddingTop: 16,
    }}
    >
      <Form.Group>
        <Form.Label>Source</Form.Label>
        <Form.Select
          value={source}
          onChange={e => {
            setSource(e.target.value);
          }}
        >
          {[FloorPlanFileSource.VIDEO, FloorPlanFileSource.CAD].map(s => (
            <option key={s} value={s}>{FloorPlanFileSourceName[s]}</option>
          ))}
        </Form.Select>
      </Form.Group>
      <Form.Group style={{
        marginTop: 16,
      }}
      >
        <Form.Label>File</Form.Label>
        <Form.Control
          type="file"
          onChange={e => {
            setFile(e.target.files[0]);
          }}
        />
      </Form.Group>
      <Button
        style={{
          marginTop: 16,
        }}
        onClick={upload}
        disabled={uploading}
      >
        Upload
      </Button>
    </div>
  );
}
